export const defaultDistanceOption = 20
